import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const NetherlandsAntillesFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14293'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14293)'>
				<rect
					x='7.61914'
					width='4.7619'
					height='14'
					fill='#D6182D'
				/>
				<rect
					y='4.66663'
					width='20'
					height='4.66667'
					fill='#1425A2'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.09533 8.16667L7.75861 8.26332L7.85724 7.93334L7.75861 7.60336L8.09533 7.70001L8.43205 7.60336L8.33343 7.93334L8.43205 8.26332L8.09533 8.16667Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.9039 8.16667L11.5672 8.26332L11.6658 7.93334L11.5672 7.60336L11.9039 7.70001L12.2406 7.60336L12.142 7.93334L12.2406 8.26332L11.9039 8.16667Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.19103 7.23333L5.85432 7.32998L5.95294 6.99999L5.85432 6.67001L6.19103 6.76666L6.52775 6.67001L6.42913 6.99999L6.52775 7.32998L6.19103 7.23333Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.8102 7.23333L13.4735 7.32998L13.5721 6.99999L13.4735 6.67001L13.8102 6.76666L14.1469 6.67001L14.0483 6.99999L14.1469 7.32998L13.8102 7.23333Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99963 6.29998L9.66291 6.39663L9.76153 6.06664L9.66291 5.73666L9.99963 5.83331L10.3363 5.73666L10.2377 6.06664L10.3363 6.39663L9.99963 6.29998Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default NetherlandsAntillesFlagIcon;
